import React from 'react';
import type { ContentItemType } from '../types/entityDetails';
import ContentDetails from './ContentDetails';

type ContentBodyProps = {
  assignees?: unknown[];
  assigneeTitle?: string;
  children?: React.ReactNode;
  contentItems?: ContentItemType[];
  entityId?: string;
  title?: React.ReactNode;
};

/**
 * @deprecated this should be replaced with composing the entity details
 * using the entity detail components, much like <OpportunityDetailsContent>
 */
export default function ContentBody({
  assignees = [],
  assigneeTitle = '',
  children = null,
  contentItems = [],
  entityId = '',
  title = null,
}: ContentBodyProps) {
  return (
    <div
      className="border-t border-grey-300 pt-5"
      {...(entityId && {
        'data-testid': `entity-details-content-${entityId}`,
      })}
    >
      {children || (
        <ContentDetails
          assignees={assignees}
          assigneeTitle={assigneeTitle}
          contentItems={contentItems}
          title={title}
        />
      )}
    </div>
  );
}
